import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mwe-header-logo-image',
  template: `<img role="presentation" src="/assets/icons/signet-bg.svg" alt="Wien Energie Stencil" class="d-inline mr-2" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLogoImageComponent {}
